import { render, staticRenderFns } from "./topBarWtxh.vue?vue&type=template&id=78b5e9df&scoped=true"
import script from "./topBarWtxh.vue?vue&type=script&lang=js"
export * from "./topBarWtxh.vue?vue&type=script&lang=js"
import style0 from "./topBarWtxh.vue?vue&type=style&index=0&id=78b5e9df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5e9df",
  null
  
)

export default component.exports